import type { IconProps } from './types';

export const Runes = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" viewBox="0 0 22 25" fill="none" aria-hidden="true" {...props}>
    <path
      d="M21.3986 0.1875L11.674 11.4077L17.1954 17.1582L0.597656 24.1875L11.674 11.4077L6.8236 6.35606L21.3986 0.1875Z"
      fill="var(--color-quanta-icon)"
    />
  </svg>
);
